import React from 'react';
import { useDispatch } from 'react-redux';
import CenterPanel from './centerPanel';
import RightPanel from './rightPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { updateOrgUnitSearch, updateRHSTotalCount } from 'actions/organisation';

export default function CreateMeetingRoom(props) {
  const dispatch = useDispatch();

  const searchInEntityPageByName = (name, cb) => {
    // Set filter to be 3 == Meeting room
    // When a new MR is created, it will navigate back to Entity Admin page;
    // Filter will be reset to meeting room and search by the new MR name
    dispatch(updateOrgUnitSearch(name));
    props.changeFilterValue(3);
    dispatch(updateRHSTotalCount('mr', 1));
    if (cb) cb();
  };

  return (
    <Modal show={props.showCreateMeetingRoomModal} hideWhenClickAway={false}>
      <PopupHeader
        title={APP.LANGUAGE.CreateUpdateMeetingRoom.TitleCreate}
        subtitle={props.organisation ? props.organisation.name + ' (' + props.organisation.abbreviatedName + ')' : ''}
        helpLink={APP.EXTERNAL_LINKS.ViewMeetingRoom.HelpCreateMeetingRoom}
      />

      <div className="content">
        <div className="main-ui-container ">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel
                  showCreateMeetingRoomModal={props.showCreateMeetingRoomModal}
                  meetingRoomForm={props.meetingRoomForm}
                  organisation={props.organisation}
                  searchInEntityPageByName={searchInEntityPageByName}
                />
              </div>
            </div>
            <CenterPanel
              showCreateMeetingRoomModal={props.showCreateMeetingRoomModal}
              meetingRoomForm={props.meetingRoomForm}
              organisation={props.organisation}
              defaultCallQuality={props.defaultCallQuality}
              callQualityOptions={props.callQualityOptions}
            />
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <RightPanel
                showCreateMeetingRoomModal={props.showCreateMeetingRoomModal}
                meetingRoomForm={props.meetingRoomForm}
                organisation={props.organisation}
                searchInEntityPageByName={searchInEntityPageByName}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
